import { AnalyticGoals } from 'shared/mechanics/analytics';
import { SubscriptionLogo } from 'shared/ui-kit';

export enum SiteSection {
	None = "NONE",
	Screener = "SCREENER",
	Map = "MAP",
	Portfolio = "PORTFOLIO",
	Articles = "ARTICLES",
	Subscription = "SUBSCRIPTION"
}

export interface MenuItem {
	section: SiteSection;
	title: string | JSX.Element;
	href: string;
	analyticsGoal?: AnalyticGoals;
}

export const MenuItems: MenuItem[] = [
	{ section: SiteSection.Screener, title: 'Скринер', href: '/screener' },
	{ section: SiteSection.Map, title: 'Карта', href: '/map' },
	{ section: SiteSection.Portfolio, title: 'Портфель', href: '/portfolio/calculator' },
	{ section: SiteSection.Articles, title: 'Статьи', href: 'https://blog.rusetfs.com/' },
	{ section: SiteSection.Subscription, title: <SubscriptionLogo />, href: '/subscription/select', analyticsGoal: AnalyticGoals.SUBSCRIPTION_MENU_ENTER }
];